import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useSubmitAnswers } from '../hooks/useSubmitAnswers'

function SurveyComponent({
  convertedSurvey,
  ac,
  tk,
  pid,
  imagesReadingTime,
  setIsLoading,
  setImagesReadingTime,
}) {
  const survey = new Model(convertedSurvey)

  // 檢查是否存在帶有 'imgWrap50' className 的元素
  function hideSdBtnIfImgWrapExists() {
    if (document.querySelector('.imgWrap50')) {
      // 如果存在，找到所有帶有 'sd-btn' className 的元素
      const sdBtnElements = document.querySelectorAll('.sd-btn')
      const thirtySecondDelete = document.querySelectorAll(
        '.thirtySecondDelete'
      )

      // 遍歷每一個 'sd-btn' 元素並設置其 display 為 'none'
      sdBtnElements.forEach((element) => {
        element.style.display = 'none'
      })

      // 30秒後恢復 'sd-btn' 元素的顯示
      setTimeout(() => {
        sdBtnElements.forEach((element) => {
          element.style.display = ''
        })
        thirtySecondDelete.forEach((element) => {
          element.style.display = 'none'
        })
        // TODO:
      }, imagesReadingTime * 1000) // 30秒
    }
  }
  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
  }

  const canShowPrevButtonPages = null

  useSubmitAnswers({
    survey,
    pid,
    ac,
    tk,
    hideSdBtnIfImgWrapExists,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    setImagesReadingTime,
  })

  return <>{convertedSurvey ? <Survey model={survey} /> : ''}</>
}

export default SurveyComponent
